import React, { Dispatch, SetStateAction } from "react";
import DyanmicalModal from "../../Common/DynamicModal";
import SetupFaceCheckBody from "./SetupFaceCheckBody";
import i18n from "../../../i18n/config";

const SetupFaceCheckModal = ({ open, setOpen }: { open: boolean, setOpen: Dispatch<SetStateAction<boolean>> }) => {
  return (
    <DyanmicalModal
      open={open}
      setClose={setOpen}
      showCloseIcon={true}
      className="setup-face-check-modal max-w-450"
      header={<h4 className="gray-1000 bold">{i18n.t("PAGES.MY_CARD.INDEX.SETUP_FACECHECK_MODAL.HEADING")}</h4>}
      body={<SetupFaceCheckBody setOpen={setOpen} />}
    />
  );
}

export default SetupFaceCheckModal;